import { Component, OnInit, Input, OnChanges, SimpleChanges, TemplateRef, ContentChild } from '@angular/core';
import { PriceAlertService } from 'src/app/api/price-alert.service';
import { PriceAlert } from 'src/app/models/price-alert';
import { AuthService } from 'src/app/api/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'price-alert-button',
  templateUrl: './price-alert-button.component.html',
  styleUrls: ['./price-alert-button.component.scss']
})
export class PriceAlertButtonComponent implements OnInit, OnChanges {
  @Input() pair: string;
  @Input() location: string;
  @Input() useGlobalCurrency = false;

  @ContentChild('activeState') activeStateTemplate: TemplateRef<any>;
  @ContentChild('inactiveState') inactiveStateTemplate: TemplateRef<any>;

  loading = false;
  error: string = null;
  data: PriceAlert;

  showModal = false;

  constructor(private auth: AuthService, private priceAlertService: PriceAlertService) { }

  ngOnInit() {
    if(this.isLoggedIn()) {
      this.getData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.isLoggedIn() &&
      changes?.pair &&
      !changes.pair.firstChange &&
      changes.pair.currentValue !== changes.pair.previousValue
    ) {
      this.getData();
    }
  }

  getData() {
    this.priceAlertService.get().subscribe(response => {
      this.loading = false;
      this.data = response.find(item => item.pair === this.pair);
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  openModal() {
    this.showModal = true;
  }

  onSave() {
    this.closeModal();
  }

  closeModal() {
    this.getData();
    this.showModal = false;
  }

  isLoggedIn() {
    return this.auth.getToken() !== null;
  }
}
